import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ZehumaLogo from './ZehumaLogo';

const linkClass = ({ isActive }) =>
    `px-3 py-2 rounded-lg text-sm font-medium transition ${
        isActive
            ? 'bg-violet-100 text-violet-800'
            : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
    }`;

const mobileLinkClass = ({ isActive }) =>
    `block rounded-xl px-4 py-3 text-base font-medium transition ${
        isActive ? 'bg-violet-100 text-violet-800' : 'text-slate-700 hover:bg-slate-100'
    }`;

export default function PortalHeader() {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (!menuOpen) return undefined;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const onKey = (e) => {
            if (e.key === 'Escape') setMenuOpen(false);
        };
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [menuOpen]);

    return (
        <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
            <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
                <ZehumaLogo />
                <nav className="hidden items-center justify-end gap-1 md:flex md:flex-wrap sm:gap-2" aria-label="Ana menü">
                    <NavLink to="/" end className={linkClass}>
                        Ana Sayfa
                    </NavLink>
                    <NavLink to="/hakkimizda" className={linkClass}>
                        Hakkımızda
                    </NavLink>
                    <NavLink to="/ozellikler" className={linkClass}>
                        Özellikler
                    </NavLink>
                    <NavLink to="/iletisim" className={linkClass}>
                        İletişim
                    </NavLink>
                </nav>

                <button
                    type="button"
                    className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 shadow-sm transition hover:bg-slate-50 md:hidden"
                    aria-expanded={menuOpen}
                    aria-controls="portal-mobile-nav"
                    onClick={() => setMenuOpen((o) => !o)}
                >
                    <span className="sr-only">{menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}</span>
                    {menuOpen ? (
                        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </button>
            </div>

            {menuOpen && (
                <>
                    <button
                        type="button"
                        className="fixed inset-0 z-[45] bg-slate-900/40 md:hidden"
                        aria-label="Menüyü kapat"
                        onClick={() => setMenuOpen(false)}
                    />
                    <nav
                        id="portal-mobile-nav"
                        className="fixed inset-y-0 right-0 z-[50] flex w-[min(100%,20rem)] flex-col gap-1 border-l border-slate-200 bg-white px-3 pb-8 pt-4 shadow-2xl md:hidden"
                        aria-label="Mobil menü"
                    >
                        <div className="mb-2 border-b border-slate-100 pb-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
                            Menü
                        </div>
                        <NavLink to="/" end className={mobileLinkClass} onClick={() => setMenuOpen(false)}>
                            Ana Sayfa
                        </NavLink>
                        <NavLink to="/hakkimizda" className={mobileLinkClass} onClick={() => setMenuOpen(false)}>
                            Hakkımızda
                        </NavLink>
                        <NavLink to="/ozellikler" className={mobileLinkClass} onClick={() => setMenuOpen(false)}>
                            Özellikler
                        </NavLink>
                        <NavLink to="/iletisim" className={mobileLinkClass} onClick={() => setMenuOpen(false)}>
                            İletişim
                        </NavLink>
                    </nav>
                </>
            )}
        </header>
    );
}
